module.exports = __webpack_public_path__ + "d308073b/img/upload-icon.9179ae4e.svg";